import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CustomService} from "../../providers/custom.service";
import {Subscription} from "rxjs";
import {UserService} from "../../providers/user.service";
import {CommonUtils} from "../../utils/common";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicCustomModalComponent} from "../vet-clinic-custom-modal/vet-clinic-custom-modal.component";
import {AppStateService} from "../../providers/app-state.service";
import {CheckboxCustomEvent, ModalController} from "@ionic/angular";
import {OrderService} from "../../providers/order.service";

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss'],
})
export class CustomComponent implements OnInit, OnDestroy {


  @ViewChild('intervalToggle') intervalToggle: HTMLIonToggleElement;
  @Input()
  vetcodeId: number;
  customData: {fields: string; results: string};
  customFields: any[];
  customFieldsForTranslate: any[];
  customRecords: any[];
  customSub: Subscription;
  setCustomSub: Subscription;
  customSubFinished: boolean;
  timeSub: Subscription;
  currentDate: {date: Date; dayTag: 'today' | 'yesterday' | 'day-before-yesterday'};
  daysOfWeek = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
  dayName: string;
  customNotSet: boolean;
  refreshCheck: boolean = true;
  interval: any;
  private orderSub: Subscription;
  private checkBoxChangedByCode: boolean;
  days: {date: Date; dayTag: 'today' | 'yesterday' | 'day-before-yesterday'}[] = [];
  dayTagMap = {
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    'day-before-yesterday': 'Przedwczoraj'
  };
  changeFromCode: boolean;
  invoiceCheckboxValues: { [dayTag: string]: { [orderUuid: string]: { print: boolean; invoice: boolean } } } = {
    today: {},
    yesterday: {},
    'day-before-yesterday': {}
  };


  constructor(private customService: CustomService, private userService: UserService,
              private translateService: TranslateService, public commonUtils: CommonUtils,
              private appStateService: AppStateService,
              private modalController: ModalController,
              private orderService: OrderService) { }

  async ngOnInit() {
    this.translateService.setDefaultLang('pl');
    this.translateService.use('pl');
    this.timeSub = this.customService.getServerTime().subscribe(serverTime => {
      if (serverTime) {
        this.days.push({date: new Date(serverTime), dayTag: 'today'});
      } else {
        this.days.push({date: new Date(), dayTag: 'today'});
      }
      this.days.push({date: new Date(this.days[0].date.getTime() - 86400000), dayTag: 'yesterday'});
      this.days.push({date: new Date(this.days[0].date.getTime() - 2 * 86400000), dayTag: 'day-before-yesterday'});
      this.currentDate = this.days[0];
      const dayOfWeekNumber = this.currentDate.date.getDay();
      this.dayName = this.daysOfWeek[dayOfWeekNumber];
      this.days.reverse();
    }, error => {
      this.days.push({date: new Date(), dayTag: 'today'});
      this.days.push({date: new Date(this.days[0].date.getTime() - 86400000), dayTag: 'yesterday'});
      this.days.push({date: new Date(this.days[0].date.getTime() - 2 * 86400000), dayTag: 'day-before-yesterday'});
      this.currentDate = this.days[0];
      const dayOfWeekNumber = this.currentDate.date.getDay();
      this.dayName = this.daysOfWeek[dayOfWeekNumber];
      this.days.reverse();
    });
    if (this.vetcodeId) {
      this.initCustomFields();
      if(!this.interval && !this.customNotSet){
        this.interval = setInterval(() => {
          if (this.vetcodeId) {
            this.initCustomFields();
          }
        }, 600000);
      }
    }
  }

  ngOnDestroy() {
    if (this.timeSub) {
      this.timeSub.unsubscribe();
    }
    if (this.customSub) {
      this.customSub.unsubscribe();
    }
    if (this.setCustomSub) {
      this.setCustomSub.unsubscribe();
    }
    if (this.orderSub) {
      this.orderSub.unsubscribe();
    }
  }


  getTranslationString(field: any) {
    if (field.objectType === 'Order') {
      return this.commonUtils.translateOrder(field.field);
    } else if (field.objectType === 'VetReservation') {
      return this.commonUtils.translateReservation(field.field);
    }
  }

  initCustomFields() {
    this.customSubFinished = false;
    this.customSub = this.customService.getCustom(Number(this.vetcodeId), this.currentDate ? this.currentDate.dayTag : 'today').subscribe((response) => {
      this.customData = response;
      if (!this.customData) {
        this.customNotSet = true;
        this.refreshCheck = false;
      } else {
        if ('fields' in this.customData) {
          this.customFields = JSON.parse(this.customData.fields);
          this.customFieldsForTranslate = JSON.parse(JSON.stringify(this.customFields));
          this.customFields = this.customFields.map(customField => {
            const objectType = customField.objectType;
            customField.objectType = objectType.charAt(0).toLowerCase() + objectType.slice(1);
            return customField;
          });

        }
        if ('results' in this.customData) {
          this.customRecords = JSON.parse(this.customData.results);
          this.restoreInvoiceSelections();
          console.log(this.customRecords);
        }
      }
      this.customSubFinished = true;
    }, error => {
      console.log(error);
      this.customSubFinished = true;
    });
  }

  handleRefreshToggle($event) {
    if (this.changeFromCode) {
      this.changeFromCode = false;
      return;
    }
    console.log($event, this.interval);
    if($event?.detail?.checked){
      if(!this.interval){
        this.interval = setInterval(() => {
          if (this.vetcodeId) {
            this.initCustomFields();
          }
        }, 600000);
      }
    } else {
      if(this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  async openCustomModal(vetcodeId: number) {
    const modal = await this.modalController.create({
      component: VetClinicCustomModalComponent,
      componentProps: {
        title: 'Konfiguruj widok dzisiejszych voucherów',
        vetCodeId: vetcodeId
      },
      cssClass: 'short-modal'
    });
    modal.onDidDismiss().then((dismissData) => {
      if(dismissData && dismissData.data && dismissData.role === 'submit') {
        const requestObj = dismissData.data;
        requestObj.vetcodeId = vetcodeId;
        console.log(requestObj);
        this.appStateService.updateIsBusySubject(true);
        this.setCustomSub = this.customService.setCustom(requestObj).subscribe(response => {
          this.commonUtils.presentInfoToast('Konfiguracja zapisana pomyślnie');
          this.appStateService.updateIsBusySubject(false);
          this.initCustomFields();
          this.customNotSet = false;
        }, error => {
          this.commonUtils.presentAlertToast('Wystąpił błąd przy zapisywaniu konfiguracji');
          this.appStateService.updateIsBusySubject(false);
        });
      }
    });
    return await modal.present();
  }

  onCheckBoxChange($event: CheckboxCustomEvent) {
    if (this.checkBoxChangedByCode) {
      this.checkBoxChangedByCode = false;
      return;
    }
    const orderStatusString = $event.detail.checked ? 'zrealizowane': 'niezrealizowane';
      this.appStateService.updateIsBusySubject(true);
      if (!$event.detail.checked) {
        this.checkBoxChangedByCode = true;
        $event.target.checked = !$event.detail.checked; // odwrócenie, aby checkbox zmienił się dopiero to kliknięciu 'Tak'
        this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz oznaczyć zamówienie jako ${orderStatusString} ?`, 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.checkBoxChangedByCode = true;
          $event.target.checked = !$event.target.checked;
          this.orderSub = this.orderService.markOrderAsCompleted(
            {completed: $event.detail.checked, orderUUID: $event.detail.value.order.uuid}).subscribe(r => {
            console.log(r);
            $event.detail.value.order.wasCompleted = 'false';
            this.commonUtils.presentInfoToast(`Pomyślnie oznaczono zamówienie jako ${orderStatusString}`);
            this.appStateService.updateIsBusySubject(false);
          }, error => {
            this.checkBoxChangedByCode = true;
            $event.target.checked = !$event.detail.checked;
            this.commonUtils.presentInfoToast(`Wystąpił błąd przy oznaczaniu zamówienia jako ${orderStatusString}`);
            this.appStateService.updateIsBusySubject(false);
          });
        }, () => {
          this.checkBoxChangedByCode = true;
          $event.target.checked = !$event.detail.checked;
          this.appStateService.updateIsBusySubject(false);
        });
      } else {
        this.orderSub = this.orderService.markOrderAsCompleted(
          {completed: $event.detail.checked, orderUUID: $event.detail.value.order.uuid}).subscribe(r => {
          console.log(r);
          $event.detail.value.order.wasCompleted = 'true';
          this.commonUtils.presentInfoToast(`Pomyślnie oznaczono zamówienie jako ${orderStatusString}`);
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.checkBoxChangedByCode = true;
          $event.target.checked = !$event.detail.checked;
          this.commonUtils.presentInfoToast(`Wystąpił błąd przy oznaczaniu zamówienia jako ${orderStatusString}`);
          this.appStateService.updateIsBusySubject(false);
        });
      }
  }

  segmentChanged($event: any) {
    if (this.currentDate?.dayTag !== $event.detail.value.dayTag) {
      console.log($event);
      this.currentDate = $event.detail.value;
      const dayOfWeekNumber = this.currentDate.date.getDay();
      this.dayName = this.daysOfWeek[dayOfWeekNumber];
      this.initCustomFields();
      if (this.currentDate.dayTag === 'today') {
        if(!this.interval){
          this.interval = setInterval(() => {
            if (this.vetcodeId) {
              this.initCustomFields();
            }
          }, 600000);
        }
      } else {
        if(this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }
      }
    }

  // Liczone z aktualnego stanu rekordów, aby etykieta przycisku zawsze odzwierciedlała
  // faktyczne zaznaczenia (także po ręcznym odznaczeniu pojedynczego rekordu i zmianie dnia).
  get allSelectedForInvoice(): boolean {
    return !!this.customRecords?.length && this.customRecords.every(record => record.selectedForInvoice);
  }

  // Dla druku pomijamy faktury już wydrukowane (ich checkbox jest disabled).
  get allSelectedForPrint(): boolean {
    if (!this.customRecords?.length) { return false; }
    const selectable = this.customRecords.filter(record => !this.isInvoicePrinted(record));
    return selectable.length > 0 && selectable.every(record => record.selectedForPrint);
  }

  toggleAllForInvoice() {
    if (!this.customRecords) { return; }
    const target = !this.allSelectedForInvoice;
    this.customRecords.forEach(record => {
      record.selectedForInvoice = target;
      this.persistInvoiceSelection(record);
    });
  }

  toggleAllForPrintConfirmation() {
    if (!this.customRecords) { return; }
    const target = !this.allSelectedForPrint;
    this.customRecords.forEach(record => {
      if (this.isInvoicePrinted(record)) { return; }
      record.selectedForPrint = target;
      this.persistInvoiceSelection(record);
    });
  }

  get selectedForPrintUuids(): string[] {
    if (!this.customRecords) { return []; }
    const uuids = this.customRecords
      .filter(record => record.selectedForPrint && !this.isInvoicePrinted(record))
      .map(record => record.order?.uuid)
      .filter(uuid => !!uuid);
    return [...new Set(uuids)];
  }

  get selectedForInvoiceUuids(): string[] {
    if (!this.customRecords) { return []; }
    const uuids = this.customRecords
      .filter(record => record.selectedForInvoice)
      .map(record => record.order?.uuid)
      .filter(uuid => !!uuid);
    return [...new Set(uuids)];
  }

  confirmPrintSelected() {
    const uuids = this.selectedForPrintUuids;
    if (!uuids.length) { return; }
    this.commonUtils.presentYesNoActionSheet(
      `Na pewno chcesz potwierdzić wydruk wybranych faktur: (${uuids.length})?`,
      'Tak', 'Nie', 'checkmark', 'close',
      () => {
        this.appStateService.updateIsBusySubject(true);
        this.orderSub = this.orderService.saveInvoicePrintStatus(uuids).subscribe(updatedUuids => {
          console.log('Zaktualizowane (order UUID):', updatedUuids);
          this.commonUtils.presentInfoToast('Potwierdzono wydruk wybranych faktur');
          this.appStateService.updateIsBusySubject(false);
          this.initCustomFields();
        }, error => {
          this.commonUtils.presentAlertToast('Wystąpił błąd przy zapisywaniu potwierdzenia wydruku faktur');
          this.appStateService.updateIsBusySubject(false);
        });
      },
      () => {}
    );
  }

  openSelectedInvoices() {
    const uuids = this.selectedForInvoiceUuids;
    if (!uuids.length) { return; }
    this.appStateService.updateIsBusySubject(true);
    this.orderSub = this.orderService.printMergedInvoices(uuids).subscribe(blob => {
      const url = URL.createObjectURL(blob);
      const anchorElement = document.createElement('a');
      anchorElement.href = url;
      anchorElement.setAttribute('download', 'faktury.pdf');
      anchorElement.click();
      anchorElement.remove();
      URL.revokeObjectURL(url);
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd przy pobieraniu złączonych faktur');
      this.appStateService.updateIsBusySubject(false);
    });
  }

  isInvoicePrinted(record: any): boolean {
    return record?.order?.wasInvoicePrinted === true || record?.order?.wasInvoicePrinted === 'true';
  }

  setPrintSelection(record: any, checked: boolean) {
    record.selectedForPrint = checked;
    this.persistInvoiceSelection(record);
  }

  setInvoiceSelection(record: any, checked: boolean) {
    record.selectedForInvoice = checked;
    this.persistInvoiceSelection(record);
  }

  private getCurrentDaySelections() {
    const dayTag = this.currentDate ? this.currentDate.dayTag : 'today';
    if (!this.invoiceCheckboxValues[dayTag]) {
      this.invoiceCheckboxValues[dayTag] = {};
    }
    return this.invoiceCheckboxValues[dayTag];
  }

  private persistInvoiceSelection(record: any) {
    this.getCurrentDaySelections()[record.order.uuid] = {
      print: !!record.selectedForPrint,
      invoice: !!record.selectedForInvoice
    };
  }

  private restoreInvoiceSelections() {
    const daySelections = this.getCurrentDaySelections();
    this.customRecords.forEach(record => {
      const stored = daySelections[record.order.uuid];
      record.selectedForPrint = stored ? stored.print : false;
      record.selectedForInvoice = stored ? stored.invoice : false;
    });
  }

  getDayTagString(dayTag: "today" | "yesterday" | "day-before-yesterday" | undefined) {

    return this.dayTagMap[dayTag];

  }
}


